import { IPOOTPVALIDATE_DATA, IPOOTPVALIDATE_ERROR_DATA, IPOOTPVALIDATE_HIDE_ERROR_DATA, IPOOTPVALIDATE_START_LOADER, IPOOTPVALIDATE_STOP_LOADER, } from "../interface/IpoOtpValidate";
import store from "@frameworks/web/redux/store";
class IpoOtpValidateActiton {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getIpoOtpValidate(IpoOtpValidate) {
        this.dispatch({
            type: IPOOTPVALIDATE_DATA,
            payload: { data: IpoOtpValidate },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: IPOOTPVALIDATE_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: IPOOTPVALIDATE_HIDE_ERROR_DATA,
        });
    }
    startLoader() {
        this.dispatch({
            type: IPOOTPVALIDATE_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: IPOOTPVALIDATE_STOP_LOADER,
        });
    }
}
export default IpoOtpValidateActiton;
